import React from "react";
import RMFDataGrid from "../shared/data-grid/RMFDataGrid";
import { Button, ButtonGroup, TableCell } from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
import { useDb } from "../../contexts/DatabaseContext";
import { Link } from "react-router-dom";

const PostsList = ({ posts }) => {
  const { deleteStandardDoc } = useDb();

  const handleDelete = async (postId) => {
    const confirm = window.confirm(
      "Are you sure you want to delete this promo post? This action cannot be undone.",
    );
    if (confirm) {
      await deleteStandardDoc("posts", postId);
    }
  };

  const rows =
    posts &&
    posts.map((post) => ({
      ...post,
    }));

  const columns = [
    {
      field: "title",
      headerName: "Title",
      width: 500,
      renderCell: (params) => {
        return (
          <Button
            href={params.row.headerImage}
            target="_blank"
            rel="noopener noreferrer"
          >
            {params.row.title}
          </Button>
        );
      },
    },
    {
      field: "id",
      headerName: "Action",
      width: 400,
      // @ts-ignore
      renderCell: (params) => {
        return (
          <TableCell>
            <ButtonGroup>
              <Link to={`/edit-posts/${params.row.id}`}>
                <Button size="small" startIcon={<Edit />} color="primary">
                  Edit
                </Button>
              </Link>
              <Button
                size="small"
                startIcon={<Delete />}
                color="error"
                onClick={() => handleDelete(params.row.id)}
              >
                Delete
              </Button>
            </ButtonGroup>
          </TableCell>
        );
      },
    },
  ];

  return <RMFDataGrid data={rows} columns={columns} />;
};

export default PostsList;
